"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.alertSchema = void 0;
const zod_1 = require("zod");
const base_1 = require("../base");
const alertBaseSchema = zod_1.z.object({
    kind: zod_1.z.literal("alert"),
    title: zod_1.z.string().nullish(),
    text: zod_1.z.string().nullish(),
    confirmButtonText: zod_1.z.string(),
    cancelButtonText: zod_1.z.string().nullish(),
    type: zod_1.z.enum(["warning", "success", "error", "info"]).nullish(),
});
exports.alertSchema = zod_1.z
    .object({})
    .merge(alertBaseSchema)
    .merge(base_1.sessionInteractionBaseSchema.extend({ from: zod_1.z.enum(["system"]) }));
//# sourceMappingURL=alert.js.map